<div class="modal__container" *ngIf="!signatureBlock">
  <h2>{{ 'opType_RVDOTP' | translate }}</h2>
  <div class="modal__content">
    <signaturit-input nameForm="nif" labelName="{{'finish_label_nif' | translate}}" [inputValue]="form?.get('nif')?.value"
      [readOnly]="isNIFReadonly" (outputValueTemplate)="setFormValue($event)" inputType="text"
      [isRequired]="!isNIFOptional" inputWidth="232" placeholderName="{{'finish_label_nif' | translate}}"></signaturit-input>
    <div class="otp__container">
      <p>{{'signaturit_pro.access-code.enter_code' | translate }} ***{{mobilePhone}}</p>
      <p *ngIf="timmer">{{'signaturit_pro.access-code.expired_code' | translate }} {{timmer}}</p>
      <ng-otp-input (onInputChange)="setFormValue({ key: 'otp', value: $event })" [config]="configInput"></ng-otp-input>
      <p *ngIf="otpError" class="error__text">{{'signaturit_pro.access-code.error_code' | translate }}</p>
      <p *ngIf="isCodeExpired" class="error__text">{{ 'signaturit_pro.access-code.expired_code_message' | translate }}</p>
      <p>{{'codigo_no_recibido' | translate }} <span (click)="forwardingOTP()">{{'reenviar_codigo' | translate}}</span></p>
    </div>
  </div>
  <div class="modal__actions">
    <signaturit-button text="{{'cancel_text' | translate }}" type="tertiary" size="md"
      (click)="exitProcess()">
    </signaturit-button>
    <signaturit-button text="{{'confirm_text' | translate }}" type="primary" size="md"
      [disabled]="!form?.valid || isLoading" [showLoader]="isLoading"
      (click)="signOTP()">
    </signaturit-button>
  </div>
</div>

<div class="document__blocked" *ngIf="signatureBlock">
  <div class="document__blocked--desktop">
    <img src="//daaj3wncgco1b.cloudfront.net/79b604b/bundles/signaturitapp/img/assets/desktop.png" alt="desktop">
  </div>
  <div class="document__blocked--content">
    <h1>{{ 'signaturit_pro.access-code.document_blocked' | translate:_transParam }}</h1>
    <h4>{{ 'signaturit_pro.access-code.document_blocked_reason' | translate:_transParam }}</h4>
    <div class="document__blocked--content_data">
      <ul class="row">
        <li class="col-xs-12 col-sm-6"><strong>{{ 'signaturit_pro.access-code.sender' | translate }}:
          </strong>{{userCreatorEmail}}</li>
        <li class="col-xs-12 col-sm-6">{{ 'signaturit_pro.access-code.document_blocked_message' | translate:_transParam
          }}</li>
        <li class="col-xs-12 col-sm-6"><strong>{{ 'usuarios_search_11' | translate:_transParam }}: </strong><span>{{
            'signaturit_pro.access-code.document_blocked' | translate:_transParam }}</span></li>
      </ul>
      <signaturit-button text="{{ 'signaturit_pro.general.exit_process' | translate:_transParam }}" type="tertiary"
        size="md" (click)="exitProcess()">
      </signaturit-button>
    </div>
  </div>
</div>
